//Wishlist Area
function wishlist_init(){    
  if(localStorage.getItem('wishlist-id') == '[]' || localStorage.getItem('wishlist-id') == null ){
    $('.wlnumber').html('0');
  }
  else{
    var activeID = [];
    activeID = JSON.parse(localStorage.getItem('wishlist-id'));
    $('.wlnumber').html(activeID.length);     
    for(i=0; i<activeID.length; i++ ){
      var classadded = '.wl-'+activeID[i];        
      $(classadded).addClass("wlc-added").removeClass("wlc").attr("title","Wishlist Added");
    }
  }
}

function wishlist_add(){
  $( "a.wlc" ).on( "click", function(e) {
    if(!$(this).hasClass('wlc-added')){
      e.preventDefault();                  

      //store product ID      
      var storeID = [];
      if(localStorage.getItem('wishlist-id') == null )
        storeID = [];
      else
        storeID = JSON.parse(localStorage.getItem('wishlist-id'));
      storeID.push($(this).data("wishlistid"));
      localStorage.setItem('wishlist-id', JSON.stringify(storeID));  

      

      //add class and update count
      setTimeout(function () {$('.wlnumber').html(storeID.length)},1000);
      $(this).addClass("wlc-added").removeClass("wlc").attr("title","Wishlist Added");
    }     
  });
}  

function wishlistdt_add(){    
  $( ".wishlist-detail a.dtwlc" ).on( "click", function(e) {
    if(!$(this).hasClass('wlc-added')){
      e.preventDefault();                  

      //store product ID      
      var storeID = [];
      if(localStorage.getItem('wishlist-id') == null )
        storeID = [];
      else
        storeID = JSON.parse(localStorage.getItem('wishlist-id'));
      storeID.push($(this).data("wishlistid"));
      localStorage.setItem('wishlist-id', JSON.stringify(storeID));  

      

      //add class and update count
      setTimeout(function () {$('.wlnumber').html(storeID.length)},1000);
      $(this).addClass("wlc-added").removeClass("dtwlc").attr("title","Wishlist Added");
    }     
  });
} 

function wishlist_show(){    
  var cont = '#wishlistcontent ul',
      productjson = '/products.json',
      getID= [];
  if(localStorage.getItem('wishlist-id') != '[]' && localStorage.getItem('wishlist-id') != null ){
    $('.wltable').removeClass('hide');
    getID = JSON.parse(localStorage.getItem('wishlist-id'));
    for(j=0; j<getID.length; j++){
      var url = "/products/"+getID[j]+".js";
      jQuery.getJSON(url, function(product) {          
        var wcn = ".wishlist-"+product.handle;    
        $(cont).append('<li class="wlr wishlist-'+product.handle+' grid__item one-whole"><div class="wishlist-image grid__item two-tenths"></div><div class="wishlist-name grid__item three-tenths"></div><div class="wishlist-price grid__item two-tenths"></div><div class="wishlist-remove grid__item one-tenth" data-wishlistid="'+product.handle+'"><i class="fa fa-times" aria-hidden="true"></i></div><div class="wishlist-detail grid__item two-tenths"></div></li>');                    
        $(wcn).find('.wishlist-image').append('<img src="'+product.featured_image+'" alt="" />');          
        $(wcn).find('.wishlist-name').append('<a href="'+product.url+'">'+product.title+'</a>'); 
        var price_compare = "";
        if ( product.compare_at_price != null ){
          price_compare='<del class="price_compare"><span class="money">'+ Shopify.formatMoney(product.compare_at_price, moneyFormat) +'</span></del>';
        }
        $(wcn).find('.wishlist-price').append('<span class="price money">'+Shopify.formatMoney(product.price, moneyFormat) + '</span>'+ price_compare);              
        $(wcn).find('.wishlist-remove').on("click", function(){ 
          $(wcn).hide("fade");
          var storeID2= [],
              ri = $(this).data("wishlistid");            
          storeID2 = JSON.parse(localStorage.getItem('wishlist-id'));            
          storeID2 = jQuery.grep(storeID2, function(value) {
            return value != ri;
          });
          localStorage.setItem('wishlist-id', JSON.stringify(storeID2));            
          $('.wlnumber').html(storeID2.length);
          if(storeID2.length == 0) {
            $('.wishlist-heading').hide();
            $('.wlempty').removeClass('hide');
          }
        });
        $(wcn).find('.wishlist-detail').append('<a href="'+product.url+'">View More</a>');
      });
    }
  }
  else{      
    $('.wishlist-heading').hide();   
    $('.wlempty').removeClass('hide');
  }
}


//Compare Area
function compare_init(){    
  if(localStorage.getItem('compare-id') == '[]' || localStorage.getItem('compare-id') == null){
    $('.cpnumber').html('0');
  }
  else{      
    var activeID = [];
    activeID = JSON.parse(localStorage.getItem('compare-id'));
    $('.cpnumber').html(activeID.length);     
    for(i=0; i<activeID.length; i++ ){
      var classadded = '.cm-'+activeID[i];        
      $(classadded).addClass("cmc-added").removeClass("cmc").attr("title","Compare Added");
    }
  }
}

function compare_add(){     
  $( "a.cmc" ).on( "click", function(e) {  
    if(!$(this).hasClass('cmc-added')){
      e.preventDefault();    

      //store product ID      
      var storeID = [];
      if(localStorage.getItem('compare-id') == null )
        storeID = [];
      else
        storeID = JSON.parse(localStorage.getItem('compare-id'));
      if(storeID.length < 3){
        storeID.push($(this).data("compareid"));
        localStorage.setItem('compare-id', JSON.stringify(storeID));                   

        

        //add class and update count
        setTimeout(function () {$('.cpnumber').html(storeID.length)},1000);
        $(this).addClass("cmc-added").removeClass("cmc").attr("title","Compare Added");

      }
      else{
        //Modal
        alert("Limited 3 products in Compare box!");
      }
    }     
  });
}    

function comparedt_add(){
        $( "a.dtcmc" ).on( "click", function(e) {
          if(!$(this).hasClass('cmc-added')){
            e.preventDefault();    
            //store product ID      
            var storeID = [];
            if(localStorage.getItem('compare-id') == null )
              storeID = [];
            else
              storeID = JSON.parse(localStorage.getItem('compare-id'));
            if(storeID.length < 3){
              storeID.push($(this).data("compareid"));
              localStorage.setItem('compare-id', JSON.stringify(storeID));                   

              

              //add class and update count
              setTimeout(function () {$('.cpnumber').html(storeID.length)},1000);
              $(this).addClass("cmc-added").removeClass("dtcmc").attr("title","Compare Added");

            }
            else{
              //Modal
              alert("Limited 3 products in Compare box!");
                    }
                    }     
                    });
            }   

function compare_check(){
  $( "#float-compare" ).on( "click", function(e) {      
    if(localStorage.getItem('compare-id') == null || localStorage.getItem('compare-id') == '[]' ){         
      $('.compare0-content').show();  
      $('.compare1-content').hide();
      $('.compare-content').hide();
    }
    else{
      var storeID = [];
      storeID = JSON.parse(localStorage.getItem('compare-id'));
      if(storeID.length == 1 ){          
        $('.compare0-content').hide();  
        $('.compare1-content').show();
        $('.compare-content').hide();
      }
      else{                      
        $('.compare0-content').hide();  
        $('.compare1-content').hide();
        $('.compare-content').show();          
        compare_show();
        setTimeout(
          function(){
            $('.compare-box').removeClass('hide');
            $('.compare-loading').hide();
          }, 1000);
      }
    }
  });
}

function showmfc(){

}
  
function compare_show(){    
  var cont = '#comparecontent ul',
      productjson = '/products.json',
      getID= [];      
  getID = JSON.parse(localStorage.getItem('compare-id'));

  if($(".col1").hasClass('hide')) {
    $(".col1").removeClass('hide');
  } else if ($(".col2").hasClass('hide')) {
    $(".col2").removeClass('hide');
  }
  if(getID.length == 2) {
    $(".col3").addClass('hide');
  }
  else{
    $(".col3").removeClass('hide');
  }
  $(".col1").html('');
  $(".col2").html('');
  $(".col3").html('');
  console.log('dap da');
  for(j=0; j<getID.length; j++){        
    var url = "/products/"+getID[j]+".js";           
    jQuery.getJSON(url, function(product) {          
      var i = 1;
      if($(".compare1-name").html() != "" ) i =2;
      if($(".compare2-name").html() != "" ) i =3;
      var image = ".compare"+i+"-image";
      var name = ".compare"+i+"-name";
      var price = ".compare"+i+"-price";
      var vendor = ".compare"+i+"-vendor";
      var type = ".compare"+i+"-type";
      var variant = ".compare"+i+"-variant";
      var available = ".compare"+i+"-available";
      var remove = ".compare"+i+"-remove";
      var remove1 = ".compare"+i+"-remove .fa-times";
      var detail = ".compare"+i+"-detail";

      //image & name
      $(image).html('<a href="'+product.url+'"><img src="'+product.featured_image+'" alt="" /></a>');
      $(name).html('<a href="'+product.url+'">'+product.title+'</a>');

      //price
      var price_compare = "";
      if ( product.compare_at_price != null ){
        price_compare='<del class="price_compare"><span class="money">'+ Shopify.formatMoney(product.compare_at_price, moneyFormat) +'</span></del>';
      }          
      $(price).html('<span class="price money">'+Shopify.formatMoney(product.price, moneyFormat) + '</span>'+ price_compare);

      //vendor & type
      $(vendor).html(product.vendor);
      $(type).html(product.type);

      //variants
      var productVariants = product.variants,
          productVariantsCount = productVariants.length,
          VariantOptions='';
      if (productVariantsCount > 1) { 
        for (var i=0; i < productVariantsCount; i++) {
          VariantOptions += '<span>'+ productVariants[i].title +'</span><br/>'
        };
      }
      $(variant).html(VariantOptions);

      //stock status
      var stockstatus;
      if(product.available) stockstatus = 'In Stock';
      else stockstatus = 'Out of Stock';
      $(available).html(stockstatus);          

      //detail
      $(detail).html('<a href="'+product.url+'">Go Detail</a>');

      //remove
      $(remove).html('<i class="fa fa-times" aria-hidden="true"></i>');
      $(remove).attr("data-compareid",product.handle);     
    })
  }    
}

function remove_func(){
  var that = this;
  var remove1 = $('[data-remove]');
  var cols = $('.compare-box').find('[data-compare]');
  var newarr = [];
  remove1.on("click", 'i', function(){ 
    var _clicked = $(this);
    var num = _clicked.parent().data('compare');
    var compareId = _clicked.parent().attr('data-compareid');
    var compareIdStorage = JSON.parse(localStorage.getItem('compare-id'));
    var compareIdIndex = compareIdStorage.indexOf(compareId);
    compareIdStorage.splice(compareIdIndex, 1);
    localStorage.setItem('compare-id', JSON.stringify(compareIdStorage));
    cols.each(function() {
      var _this = $(this);
      if(_this.data('compare') == num) {
        _this.empty();
        _this.addClass('hide');
      }
    });
    $('.cpnumber').html(compareIdStorage.length);
    if(compareIdStorage.length == 1) {
      $.magnificPopup.close();
    }
    var riclass = '.cm-' + compareId;
    $(riclass).addClass("cmc").removeClass("cmc-added").attr("title","Add to Compare");

  }); 


}
        

$(document).ready(function($) {  
  wishlist_init();
  wishlist_add();
  if(wlpage) wishlist_show();
  if(tada_detail) wishlistdt_add();
  
  compare_init();
  compare_add();
  if(tada_detail) comparedt_add();
  $('#float-compare').magnificPopup({
    type: 'inline',
    mainClass: 'mfp-fade',
    closeOnBgClick: true,
    closeBtnInside: false,
    closeOnContentClick: false,
    tClose: theme.strings.zoomClose,
    alignTop: true,
    removalDelay: 500
  });
  
  compare_check();    
  remove_func();
    
  $('.qropt-ios').on('click', function(){
    if($('.qrimg-ios').hasClass('hide')) $('.qrimg-ios').addClass('show').removeClass('hide');
    else $('.qrimg-ios').addClass('hide').removeClass('show');
  });
            
  $('.qropt-android').on('click', function(){
    if($('.qrimg-android').hasClass('hide')) $('.qrimg-android').addClass('show').removeClass('hide');
    else $('.qrimg-android').addClass('hide').removeClass('show');
  });
});